import { deepClone } from '../../../utils/object'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export const initialState = {
  adverts: [],
  auctionId: 0,
  employerSearchOccupations: [],
  filter: null,
  intervalFrom: '',
  intervalTo: '',
  isSearchTriggered: false,
  selectedBidCard: null
}

let state = deepClone(initialState)

const store = {
  state,
  actions,
  getters,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/arena/index.js